/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'
import { Route as AppCategoriesIndexRouteImport } from './routes/_app/categories/index'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersIdRouteImport } from './routes/_app/customers/$id'
import { Route as AppSettingsCustomersRouteImport } from './routes/_app/settings/customers'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppSettingsGroupsIndexRouteImport } from './routes/_app/settings/groups/index'
import { Route as AppSettingsGroupsIdServicesRouteImport } from './routes/_app/settings/groups/$id.services'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCategoriesIndexRoute = AppCategoriesIndexRouteImport.update({
  id: '/categories/',
  path: '/categories/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIdRoute = AppCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCustomersRoute = AppSettingsCustomersRouteImport.update({
  id: '/settings/customers',
  path: '/settings/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIndexRoute = AppSettingsGroupsIndexRouteImport.update({
  id: '/settings/groups/',
  path: '/settings/groups/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIdServicesRoute =
  AppSettingsGroupsIdServicesRouteImport.update({
    id: '/settings/groups/$id/services',
    path: '/settings/groups/$id/services',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/settings/customers': typeof AppSettingsCustomersRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/categories/': typeof AppCategoriesIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesByTo {
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/settings/customers': typeof AppSettingsCustomersRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/categories': typeof AppCategoriesIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/settings/groups': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/customers/$id': typeof AppCustomersIdRoute
  '/_app/settings/customers': typeof AppSettingsCustomersRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/categories/': typeof AppCategoriesIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/_app/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth/launch'
    | '/customers/$id'
    | '/settings/customers'
    | '/settings/users'
    | '/categories/'
    | '/customers/'
    | '/settings/groups/'
    | '/settings/groups/$id/services'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth/launch'
    | '/'
    | '/customers/$id'
    | '/settings/customers'
    | '/settings/users'
    | '/categories'
    | '/customers'
    | '/settings/groups'
    | '/settings/groups/$id/services'
  id:
    | '__root__'
    | '/_app'
    | '/auth/launch'
    | '/_app/'
    | '/_app/customers/$id'
    | '/_app/settings/customers'
    | '/_app/settings/users'
    | '/_app/categories/'
    | '/_app/customers/'
    | '/_app/settings/groups/'
    | '/_app/settings/groups/$id/services'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/categories/': {
      id: '/_app/categories/'
      path: '/categories'
      fullPath: '/categories/'
      preLoaderRoute: typeof AppCategoriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$id': {
      id: '/_app/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AppCustomersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/customers': {
      id: '/_app/settings/customers'
      path: '/settings/customers'
      fullPath: '/settings/customers'
      preLoaderRoute: typeof AppSettingsCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/': {
      id: '/_app/settings/groups/'
      path: '/settings/groups'
      fullPath: '/settings/groups/'
      preLoaderRoute: typeof AppSettingsGroupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/$id/services': {
      id: '/_app/settings/groups/$id/services'
      path: '/settings/groups/$id/services'
      fullPath: '/settings/groups/$id/services'
      preLoaderRoute: typeof AppSettingsGroupsIdServicesRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppCustomersIdRoute: typeof AppCustomersIdRoute
  AppSettingsCustomersRoute: typeof AppSettingsCustomersRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppCategoriesIndexRoute: typeof AppCategoriesIndexRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppSettingsGroupsIndexRoute: typeof AppSettingsGroupsIndexRoute
  AppSettingsGroupsIdServicesRoute: typeof AppSettingsGroupsIdServicesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppCustomersIdRoute: AppCustomersIdRoute,
  AppSettingsCustomersRoute: AppSettingsCustomersRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppCategoriesIndexRoute: AppCategoriesIndexRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppSettingsGroupsIndexRoute: AppSettingsGroupsIndexRoute,
  AppSettingsGroupsIdServicesRoute: AppSettingsGroupsIdServicesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
